import React, { Component } from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap';
import PropTypes from 'prop-types';

import './Dialog.scss';

class Dialog extends Component {

  render() {

    let clazzName = 'modal-dialog-centered modal-size-' + this.props.size + ' ' + this.props.className;

    return (
      <Modal isOpen={this.props.show} className={clazzName}>
        <ModalHeader>{this.props.title}</ModalHeader>
        <ModalBody>
          {this.props.children}
        </ModalBody>
        <ModalFooter>
          {this.props.cancelButton
            ? this.props.cancelButton()
            : <Button color="secondary" onClick={this.props.onCancel}>{this.props.cancel}</Button>
          }
          {this.props.confirmButton
            ? this.props.confirmButton()
            : (<Button color="primary" onClick={this.props.onConfirm}>{this.props.confirm}</Button>)
          }
        </ModalFooter>
      </Modal>
    );
  }

}

Dialog.propTypes = {
  title: PropTypes.string.isRequired,
  confirm: PropTypes.string,
  cancel: PropTypes.string,
  show: PropTypes.bool,
  children: PropTypes.node,
  onConfirm: PropTypes.func,
  onCancel: PropTypes.func,
  confirmButton: PropTypes.func,
  cancelButton: PropTypes.func,
  fullScreen: PropTypes.bool,
  size: PropTypes.string
}

Dialog.defaultProps = {
  cancel: 'Cancel',
  confirm: 'OK',
  show: false,
  size: 'small'
};

export default Dialog;
